import { render, staticRenderFns } from "./grab-center-table.vue?vue&type=template&id=cfd486f6"
import script from "./grab-center-table.vue?vue&type=script&lang=js"
export * from "./grab-center-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports